module.exports = __webpack_public_path__ + "img/样例数据缩略图.e6f0bd83.jpg";